export default __webpack_public_path__ + "static/media/ManagementIcon.3a6e91b9.svg";